import { useState } from "react";

interface FAQItem {
  question: string;
  answer: string;
}

const faqs: FAQItem[] = [
  {
    question: "AI 웨딩 사진은 어떻게 만들어지나요?",
    answer:
      "신부와 신랑의 개별 사진을 각각 업로드해주시면, AI가 두 분의 얼굴을 학습한 뒤 선택하신 스타일과 톤에 맞춰 자연스러운 웨딩 사진을 생성합니다. 실제 스튜디오에서 촬영한 것 같은 고퀄리티 결과물을 받아보실 수 있습니다.",
  },
  {
    question: "사진은 몇 장 업로드해야 하나요?",
    answer:
      "신부, 신랑 각각 정면 사진과 측면 사진을 포함하여 최소 2장 이상 업로드해주세요. 다양한 각도와 표정의 사진을 올려주실수록 더 자연스러운 결과물을 얻을 수 있습니다. 선명하고 얼굴이 잘 보이는 사진을 권장드립니다.",
  },
  {
    question: "결과물은 얼마나 걸리나요?",
    answer:
      "결제 완료 후 보통 24시간 이내에 결과물을 받아보실 수 있습니다. 주문량에 따라 다소 차이가 있을 수 있으며, 완료 시 등록하신 이메일 또는 마이페이지에서 확인하실 수 있습니다.",
  },
  {
    question: "환불은 가능한가요?",
    answer:
      "결제 완료 후 AI 이미지 생성이 시작되기 전까지는 전액 환불이 가능합니다. 다만, 이미지 생성이 시작된 이후에는 환불이 불가하오니 주문 전 신중하게 확인해주세요.",
  },
  {
    question: "업로드한 사진은 안전한가요?",
    answer:
      "네, 안전합니다. 업로드된 사진은 AI 웨딩 사진 생성 목적으로만 사용되며, 생성 완료 후 30일 이내에 서버에서 자동 삭제됩니다. AI 모델 학습이나 마케팅 등 다른 목적으로 사용하지 않습니다.",
  },
  {
    question: "요금제별 차이가 뭔가요?",
    answer:
      "요금제에 따라 생성되는 사진 수가 달라집니다. 베이직은 10장(19,900원), 스탠다드는 30장(39,900원), 프리미엄은 40장(59,900원)이며, 각 사진당 최대 2번까지 무료로 재생성할 수 있습니다. 현재 오픈 기념 특별 할인가로 제공 중입니다.",
  },
  {
    question: "재생성과 다운로드는 언제까지 가능한가요?",
    answer:
      "서비스 제공기간은 결제일로부터 3개월입니다. 해당 기간 내에 사진당 최대 2회까지 재생성이 가능하며, 완성된 사진의 다운로드도 같은 기간 내에 이용하실 수 있습니다. 기간이 지나면 재생성 및 다운로드 기능이 제한되니, 결제 후 기한 내에 이용해 주세요.",
  },
  {
    question: "생성된 사진을 상업적으로 사용해도 되나요?",
    answer:
      "생성된 AI 웨딩 사진의 사용권은 이용자에게 부여되며, 개인적 용도(SNS 게시, 청첩장, 액자 등)로 자유롭게 사용하실 수 있습니다. 상업적 이용에 대해서는 별도 문의해주세요.",
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-24 bg-white">
      <div className="max-w-3xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-xs tracking-[0.3em] uppercase text-[#C9A96E] font-medium">
            FAQ
          </span>
          <h2 className="font-serif text-4xl font-light text-[#2D2D2D] mt-3 mb-4">
            자주 묻는 질문
          </h2>
          <p className="text-gray-500 text-sm font-light">
            궁금하신 점이 있으시면 아래에서 확인해보세요
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border border-gray-200 rounded-2xl overflow-hidden transition-all duration-300 hover:border-[#C9A96E]/30"
            >
              <button
                onClick={() => toggle(index)}
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer"
              >
                <span className="text-[15px] font-medium text-[#2D2D2D] pr-4">
                  {faq.question}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-xl text-[#C9A96E] transition-transform duration-300 shrink-0 ${
                    openIndex === index ? "rotate-180" : ""
                  }`}
                ></i>
              </button>
              <div
                className={`grid transition-all duration-300 ease-in-out ${
                  openIndex === index
                    ? "grid-rows-[1fr] opacity-100"
                    : "grid-rows-[0fr] opacity-0"
                }`}
              >
                <div className="overflow-hidden">
                  <p className="px-6 pb-5 text-sm text-gray-500 font-light leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-sm text-gray-400 font-light">
            더 궁금한 점이 있으신가요?{" "}
            <a
              href="http://pf.kakao.com/_BLxhxhX"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#C9A96E] hover:underline"
            >
              카카오 채널로 문의하기
            </a>
          </p>
        </div>
      </div>
    </section>
  );
}
